import { useThree } from "@react-three/fiber";
import { useContext, useLayoutEffect } from "react";
import { useDragStore } from "../stores/dragStore";
import { ProductStoreContext } from "./ProductStoreContext";
import {
  markProductSceneChanged,
  subscribeToSceneChanges,
} from "./sceneActivity";

export function useProductSceneActivity(): void {
  const scene = useThree((state) => state.scene);
  const invalidate = useThree((state) => state.invalidate);
  const store = useContext(ProductStoreContext);

  useLayoutEffect(() => {
    const unsubscribe = subscribeToSceneChanges(scene, () => invalidate());
    markProductSceneChanged(scene);
    return unsubscribe;
  }, [scene, invalidate]);

  useLayoutEffect(() => {
    if (!store) return;
    return store.subscribe((state, previous) => {
      if (
        state.product !== previous.product ||
        state.buildVersion !== previous.buildVersion ||
        state.hiddenPartTypes !== previous.hiddenPartTypes ||
        state.showEdges !== previous.showEdges ||
        state.showGround !== previous.showGround ||
        state.showLids !== previous.showLids ||
        // Swapping the scene takes the floor grid in or out of the picture,
        // which the contact shadow and the AO both have to see.
        state.selectedSceneId !== previous.selectedSceneId ||
        state.showAmbientOcclusionBuffer !== previous.showAmbientOcclusionBuffer
      ) {
        markProductSceneChanged(scene);
      }
    });
  }, [scene, store]);

  useLayoutEffect(
    () =>
      useDragStore.subscribe((state, previous) => {
        if (state.isDragActive !== previous.isDragActive) {
          markProductSceneChanged(scene);
        }
      }),
    [scene],
  );
}
